module.exports = __webpack_public_path__ + "static/green-bar-65426cf51f7262e6a5bab26f19e5c237.jpg";